import React from "react";
import { LabeledValue } from "antd/lib/select";
import BrokerMultiSelect from "../../select/MultiSelect/BrokerMultiSelect";
import { FilterDropdownProps } from "antd/lib/table/interface";
import FilterContainer from "./FilterContainer";
import { DELAY_TIMER_SEARCH_FILTER, endAndStartTimerFilter } from "./columnsUtils";

export default function BrokerFilter({isReconciliationBroker = false, ...props}: FilterDropdownProps & { isReconciliationBroker?: boolean }) {

  return <FilterContainer {...props}>
    <BrokerMultiSelect
      isReconciliationBroker={isReconciliationBroker}
      style={{ width: "20rem" }}
      onChange={(values: LabeledValue[]) => {
        // @ts-ignore
        props.setSelectedKeys(values.reverse().map(el => ({ label: el.label, value: el.value })));
        endAndStartTimerFilter(props.confirm, DELAY_TIMER_SEARCH_FILTER);
      }}
      value={props.selectedKeys}
    />
  </FilterContainer>;

}